import { Nullable } from '@clearverify/types';

import { useGetDashboardLastUploadRolesQuery } from 'src/api';

type UseDashboardLastUploadRolesParams = {
  employerId?: Nullable<string>;
  peoId?: Nullable<string>;
  skip?: boolean;
};

/**
 * Last successful MDM load for a single org. MDM only answers for one Employer or one PEO, so
 * without a single-org scope there is nothing to ask for and the query is skipped.
 */
export const useDashboardLastUploadRoles = ({
  employerId,
  peoId,
  skip,
}: UseDashboardLastUploadRolesParams) => {
  const { data, loading } = useGetDashboardLastUploadRolesQuery({
    variables: { employerId, peoId },
    skip: skip || (!employerId && !peoId),
  });

  return {
    lastUploadRoles: data?.getDashboardLastUploadRoles ?? null,
    lastUploadRolesLoading: loading,
  };
};
